import styled from 'styled-components';

export const ButtonWrapper = styled.div`
    width: 200px;
    right: 0;
    bottom: 0;
    position: absolute;
    transform: translate(0, 50%);
`;
